var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 44.7667C45.7437 44.7667 50.4 40.1104 50.4 34.3667C50.4 28.6229 45.7437 23.9667 40 23.9667C34.2562 23.9667 29.6 28.6229 29.6 34.3667C29.6 40.1104 34.2562 44.7667 40 44.7667Z",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0667 28.3C18.6334 -0.566665 61.4 -0.533331 67.9334 28.3333C71.7667 45.2667 61.2334 59.6 52 68.4667C45.3 74.9333 34.7 74.9333 27.9667 68.4667C18.7667 59.6 8.23336 45.2333 12.0667 28.3Z",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a905df321f929d4c6d90578ed838d742.svg";
export { ForwardRef as ReactComponent };